import { Apartment, Assignment, People } from '@mui/icons-material'
import {
    BottomNavigationAction,
    type BottomNavigationProps,
    BottomNavigation as MuiBottomNavigation,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { recruiterRouteConfig } from 'recruiter/routes'

export function BottomNavigation() {
    const location = useLocation()
    const navigate = useNavigate()

    const handleBottomNavChange: BottomNavigationProps['onChange'] = (
        _event,
        newValue
    ) => {
        navigate(newValue)
    }

    return (
        <MuiBottomNavigation
            onChange={handleBottomNavChange}
            showLabels
            value={location.pathname}
            sx={(theme) => ({
                backgroundColor: theme.palette.primary.dark,
                boxShadow: 'none',
                color: theme.palette.common.white,

                '.MuiBottomNavigationAction-root': {
                    color: theme.palette.common.white,
                },

                '.MuiBottomNavigationAction-root.Mui-selected': {
                    color: theme.palette.primary.light,
                },

                '.Mui-focusVisible': {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.main,

                    '.MuiBottomNavigationAction-root': {
                        color: theme.palette.primary.main,
                    },
                },
            })}
        >
            <BottomNavigationAction
                label="People"
                icon={<People />}
                value={recruiterRouteConfig.candidates.path}
            />
            <BottomNavigationAction
                label="Searches"
                icon={<Assignment />}
                value={recruiterRouteConfig.rosters.path}
            />
            <BottomNavigationAction
                label="Companies"
                icon={<Apartment />}
                value={recruiterRouteConfig.companies.path}
            />
        </MuiBottomNavigation>
    )
}
